import React from 'react';

function PetCare() {
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">宠护到家</h1>
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">专业上门宠物护理服务</h5>
              <p className="card-text">
                我们提供专业的上门宠物护理服务，包括但不限于：
              </p>
              <ul className="list-group list-group-flush mb-3">
                <li className="list-group-item">上门猫咪健康检查</li>
                <li className="list-group-item">猫咪洗澡和毛发护理</li>
                <li className="list-group-item">猫咪行为训练</li>
                <li className="list-group-item">猫咪日常照料</li>
                <li className="list-group-item">猫咪饮食咨询</li>
              </ul>
              <p className="card-text">
                我们的专业团队由经验丰富的宠物护理师组成，他们接受过专业培训，能够为您的猫咪提供最优质的服务。
              </p>
              <button className="btn btn-primary">预约服务</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PetCare;
